import { InjectionToken } from '@angular/core';
import { ToastMessageData } from './toast-message-data.interface';

export const TOAST_MESSAGE_DATA = new InjectionToken<ToastMessageData>('TOAST_MESSAGE_DATA');
